import { CommandResult } from '../amorg-common'
import { OrganizationOwner } from '../amorg-common'
import { apiPath } from "./../amorg-common";
import { commandAuthWrapper, queryAuthWrapper } from "./serverApiHelpers";


const organizationSettingsPath = `${apiPath}/organizationsettings`;

export const updateOwner = async (owner: OrganizationOwner): Promise<CommandResult> =>
    commandAuthWrapper(`${organizationSettingsPath}/owner`, 'POST', owner);


export const getOwner = async (): Promise<OrganizationOwner> =>
    queryAuthWrapper(`${organizationSettingsPath}/owner`);